var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{class:[{'mt-4':!_vm.noMarginTop}],style:(_vm.style),attrs:{"align":"center"}},[_c('v-spacer'),_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.color,"size":_vm.size}}),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }